import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';


import { AppStorageService } from './app-storage.service';
import { JWTHandlerService } from './jwthandler.service';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root',
})
export class AppLoadService {
  constructor(private http: HttpClient, private storage: AppStorageService, private jwt: JWTHandlerService) { }

  initApp() {
    return Promise.all([this.generateAppToken()]);
  }

  generateAppToken(): any {
    return new Promise<any>((resolve) => {
      let appToken = this.storage.appToken;

      let userToken = this.storage.userToken;

      if (userToken && this.jwt.isExpired(userToken)) {
        this.storage.deleteUserToken();
        this.storage.deleteUserDataResponse();
      }

      if (!appToken || (appToken && this.jwt.isExpired(appToken))) {
        this.getAppToken().subscribe({
          next: (response: any) => {
            this.storage.appToken = response.access_token;
            resolve(null);
          },
          error: (error) => { },
        });
      } else {
        resolve(null);
      }
    });
  }

  getAppToken() {
    var headers = {
      'Content-Type': 'application/x-www-form-urlencoded',
    };

    var body = `grant_type=${environment.grantType}&client_id=${environment.clientId}&client_secret=${environment.clientSecret}&scope=${environment.scope}`;

    return this.http.post(environment.serverUrl +'/identity-server/connect/token', body, { headers: headers });
  }
}
